module.exports = __webpack_public_path__ + "assets/img/login-1.bc8b887e.gif";